import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { IntranetoldService } from 'src/app/api/intranetold.service';
import { SapService } from 'src/app/api/sap.service';
import { SeleccionarDocumentoComponent } from './seleccionar-documento/seleccionar-documento.component';
import { variableGlobal } from 'src/app/global.enum';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { VentaLayaultModelComponent } from 'src/app/intranet/layout/venta/venta-layault-model';

@Component({
  selector: 'app-oportunidad-detalle',
  templateUrl: './oportunidad-detalle.component.html',
  styleUrls: ['./oportunidad-detalle.component.css']
})
export class OportunidadDetalleComponent implements OnInit {

  constructor
    (
      private route: ActivatedRoute,
      private _sap: SapService,
      private _api: IntranetoldService,
      private modalService: NgbModal,
      private router: Router,
    ) { }

  id: any;
  data: any;
  cargando: boolean = false;
  Etapas: any;
  ActividadesTipos: any;
  ActividadesAsuntos: any;
  ActividadNueva: any
  Actividades: any;
  Archivos: any;

  CIERRE_PREVISTO: any;
  MONTO_PONDERADO: any;

  async ngOnInit(): Promise<void> {
    this.cargaInicial();
  }

  async cargaInicial() {
    this.cargando = true;
    this.id = this.route.snapshot.paramMap.get('id');
    let res: any = await this._sap.obtieneOportunidad(this.id);
    this.data = res.resultado;

    let resUsers: any = await this._api.getAllLogin();

    if (resUsers.estado) {
      resUsers = [...resUsers.objeto];
    }

    let Actividades: any = await this._api.GetNotFileQuery('SELECT * FROM OCLG WHERE [U_IND_ID_OPOR] = ' + this.id);
    
    this.Actividades = Actividades.objeto;

    let Archivos: any = await this._api.GetNotFileQuery('SELECT * FROM ATC1 WHERE [AbsEntry] = ' + this.data.AtcEntry);
    this.Archivos = Archivos.objeto;


    this.Actividades.forEach(element => {
      element.Usuario = resUsers.filter(x => x.RUT == element.U_IND_ID_INTRANET)[0].NOMBRE;
    });

    let Etapas: any = await this.obtieneQueryMongo('OportunidadEtapas');
    Etapas = await this._api.GetNotFileQuery(Etapas);
    this.Etapas = Etapas.objeto;

    let ActividadesTipos: any = await this.obtieneQueryMongo('ActividadesTipos');
    ActividadesTipos = await this._api.GetNotFileQuery(ActividadesTipos);
    this.ActividadesTipos = ActividadesTipos.objeto;

    let ActividadesAsuntos: any = await this.obtieneQueryMongo('ActividadesAsuntos');
    ActividadesAsuntos = await this._api.GetNotFileQuery(ActividadesAsuntos);
    
    this.ActividadesAsuntos = ActividadesAsuntos.objeto;

    
    
    
    
    
    

    this.ActividadNueva =
    {
      "ClgCode": 0,
      "CardCode": this.data.CardCode,
      "Notes": "",
      "CntctDate": new Date(),
      "CntctTime": 1056,
      "Recontact": new Date(),
      "Closed": "N",
      "CloseDate": null,
      "ContactPer": null,
      "Tel": "990793427",
      "Fax": null,
      "CntctSbjct": -1,
      "Transfered": "N",
      "DocType": "-1",
      "DocNum": "",
      "DocEntry": "",
      "Attachment": "",
      "DataSource": "I",
      "AttendUser": 1,
      "CntctCode": 0,
      "UserSign": 1,
      "SlpCode": -1,
      "Action": "",
      "Details": "",
      "CntctType": -1,
      "Location": -1,
      "BeginTime": 1050,
      "Duration": 900.000000,
      "DurType": "S",
      "ENDTime": 1105,
      "Priority": "1",
      "Reminder": "Y",
      "RemQty": 15.000000,
      "RemType": "M",
      "OprId": 0,
      "OprLine": 0,
      "RemDate": new Date(),
      "RemTime": 1035,
      "RemSented": "N",
      "Instance": 0,
      "endDate": new Date(),
      "status": null,
      "personal": "N",
      "inactive": "N",
      "tentative": "N",
      "street": null,
      "city": null,
      "country": null,
      "state": null,
      "room": null,
      "parentType": "0",
      "parentId": 0,
      "prevActvty": null,
      "AtcEntry": null,
      "RecurPat": "N",
      "EndType": "N",
      "SeStartDat": new Date(),
      "SeEndDat": null,
      "MaxOccur": null,
      "Interval": 1,
      "Sunday": "N",
      "Monday": "N",
      "Tuesday": "N",
      "Wednesday": "N",
      "Thursday": "N",
      "Friday": "N",
      "Saturday": "N",
      "SubOption": "1",
      "DayInMonth": null,
      "Month": null,
      "DayOfWeek": null,
      "Week": null,
      "SeriesNum": null,
      "OrigDate": null,
      "IsRemoved": "N",
      "LastRemind": null,
      "AssignedBy": 1,
      "AddrName": null,
      "AddrType": "S",
      "AttendEmpl": null,
      "NextDate": null,
      "NextTime": null,
      "OwnerCode": null,
      "AttendReci": null,
      "ActType": null,
      "LaborItem": null,
      "ResCode": null,
      "FIPROJECT": null,
      "UpdateDate": new Date(),
      "LogInstanc": 0,
      "UserSign2": null,
      "DPPStatus": "N",
      "CreateDate": new Date(),
      "EncryptIV": null,
      "DataVers": 1,
      "Of365EvtId": null,
      "AssigneeTy": 12,
      "VersionNum": "10.00.180.08",
      "userFields": [
        {
          "Field": "U_IND_ID_INTRANET",
          "FieldType": null,
          "Value": localStorage.getItem("RUT_LOGUEADO"),
          "TypeHTML": null,
          "MaxLength": null,
          "Step": null,
          "Description": null
        },
        {
          "Field": "U_IND_ID_OPOR",
          "Value": this.id,
        }
      ]
    }

    this.CIERRE_PREVISTO = this.formatDate(this.data.PredDate);

    this.cargando = false;
  }

  formatDate(fechaOriginal: any) {
    // Convertir la fecha a un objeto Date
    const fechaDate: Date = new Date(fechaOriginal);

    // Obtener los componentes de la fecha
    const year: number = fechaDate.getFullYear();
    const month: number = fechaDate.getMonth() + 1; // ¡Añadir 1 ya que en JavaScript los meses comienzan desde 0!
    const day: number = fechaDate.getDate();

    // Formatear la fecha en formato 'yyyy-MM-dd'
    return `${year}-${this.padZero(month)}-${this.padZero(day)}`;
  }

  padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  actualizarDatos(title: any) {

    Swal.fire({
      title: '¿Estás seguro que deseas actualizar ' + title + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí'
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.cargando = true;

        this.data.PredDate = this.obtenerFechaActualEnFormato(this.CIERRE_PREVISTO);
        this.data.OPR1[this.data.OPR1.length - 1].MaxSumLoc = this.data.MaxSumLoc;

        let res: any = await this._sap.creaActualizaOportunidad(this.data);
        

        if (res.estado) {
          Swal.fire({
            icon: 'success',
            title: 'Éxito',
            text: res.mensaje,
          });
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: res.mensaje,
          });
        }

        this.cargando = false;
      }
    });
  }

  async obtieneQueryMongo(nombre) {
    var data: any = await this._api.getQueryAll();
    var query: string = "";
    await data.objeto.forEach(element => {
      if (element.NOMBRE == nombre) {
        query = element.CONSULTA;
      }
    });

    return query;
  }

  nuevaEtapa = {
    "OpprId": -1,
    "Line": -1,
    "SlpCode": -1,
    "CntctCode": null,
    "Step_Id": 0,
    "ClosePrcnt": 0,
    "MaxSumLoc": 0,
    "MaxSumSys": 0,
    "Memo": "",
    "DocId": null,
    "ObjType": "-1",
    "Status": "C",
    "Linked": "false",
    "WtSumLoc": 0,
    "WtSumSys": 0,
    "UserSign": null,
    "ChnCrdCode": null,
    "ChnCrdName": null,
    "ChnCrdCon": null,
    "DocChkbox": null,
    "Owner": null,
    "DocNumber": null,
    "EncryptIV": null,
    "userFields": []
  }

  async actualizaOportunidadFast() {
    let res: any = await this._sap.creaActualizaOportunidad(this.data);
    
  }

  async enviarLinea() {
    this.cargando = true;

    if (this.nuevaEtapa.Memo) {

      this.nuevaEtapa.OpprId = this.data.OpprId;
      this.data.OPR1.push(this.nuevaEtapa);
      
      let res: any = await this._sap.creaActualizaOportunidad(this.data);
      

      if (res.estado) {
        this.nuevaEtapa = {
          "OpprId": -1,
          "Line": -1,
          "SlpCode": -1,
          "CntctCode": null,
          "Step_Id": 0,
          "ClosePrcnt": 0,
          "MaxSumLoc": 0,
          "MaxSumSys": 0,
          "Memo": "",
          "DocId": null,
          "ObjType": "-1",
          "Status": "C",
          "Linked": "false",
          "WtSumLoc": 0,
          "WtSumSys": 0,
          "UserSign": null,
          "ChnCrdCode": null,
          "ChnCrdName": null,
          "ChnCrdCon": null,
          "DocChkbox": null,
          "Owner": null,
          "DocNumber": null,
          "EncryptIV": null,
          "userFields": []
        }



      }
      else {
        Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        }).fire({
          icon: 'error',
          title: res.MENSAJE
        });
      }

    }
    else {
      Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      }).fire({
        icon: 'error',
        title: "El comentario es obligatorio"
      });
    }


    this.cargando = false;

  }

  async seleccionarDocumento() {

    if (this.nuevaEtapa.ObjType != "-1") {

      let ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
        size: "xl",
        modalDialogClass: variableGlobal.CLASS_MODAL_BG
      };
      const modalRef = this.modalService.open(SeleccionarDocumentoComponent, ngbModalOptions);
      //modalRef.componentInstance.data = this.OCRD;
      if (this.nuevaEtapa.ObjType == "17") {
        modalRef.componentInstance.tipoDocumento = 'NV';
      }
      else if (this.nuevaEtapa.ObjType == "23") {
        modalRef.componentInstance.tipoDocumento = 'COT';
      }

      modalRef.componentInstance.CardCode = this.data.CardCode;

      modalRef.componentInstance.modalReference = modalRef;
      modalRef.result.then(async (data) => {

        if (data) {
          
          this.nuevaEtapa.DocId = data.DocEntry;
          this.nuevaEtapa.MaxSumLoc = data.DocTotal;
        }


      }, (reason) => {
        //this.editar(item);
      });

    }
    else {
      Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      }).fire({
        icon: 'error',
        title: '¡Debe seleccionar un Tipo de Documento!',
      });
    }

  }

  async abrirOjo(datoEtapa: any) {

    this.cargando = true;

    var objeto = "SELECT * FROM [OSLP]";
    var dato: any = await this._api.GetNotFileQuery(objeto);

    var data: any = await this._api.getQueryAll();
    var query: string = "";
    var arreglo: any;


    await data.objeto.forEach(element => {
      if (element.NOMBRE == "OPORTUNIDAD_DETALLE_DOCNUM_ETAPA") {
        objeto = element.CONSULTA;
      }
    });

    dato = await this._api.GetNotFileQuery(objeto);
    arreglo = dato.objeto;


    arreglo = arreglo.filter(item => item.DocNum == datoEtapa.DocNumber && this.data.OpprId == datoEtapa.OpprId)

    this.abrirLayout(arreglo[0]);

    this.cargando = false;

  }

  abrirLayout(item) {

    

    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      scrollable: true
    };

    
    

    var urlIframe = environment.RUTA_API + "/WEB/viewLayault?ObjType=" + item.ObjType + "&DocEntry=" + item.DocEntry;
    var urlImprimir = environment.RUTA_API + "/WEB/viewLayoultPDF?ObjType=" + item.ObjType + "&DocEntry=" + item.DocEntry;
    
    const modalRef = this.modalService.open(VentaLayaultModelComponent, ngbModalOptions);
    modalRef.componentInstance.ObjType = item.ObjType;
    modalRef.componentInstance.DocEntry = item.DocEntry;
    modalRef.componentInstance.urllayout = urlIframe;
    modalRef.componentInstance.urlImprimir = urlImprimir;


    modalRef.componentInstance.DocNum = item.DocNum;
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.result.then((data) => {


    }, (reason) => {
      //this.editar(item);
    });
  }

  obtenerFechaActualEnFormato(date?): string {

    let fecha = new Date();

    if (date) {
      fecha = new Date(date)
    }

    const año = fecha.getFullYear();
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Mes comienza desde 0
    const dia = fecha.getDate().toString().padStart(2, '0');
    const horas = '00';
    const minutos = '00';
    const segundos = '00';

    const fechaFormateada = `${año}-${mes}-${Number(dia) + 1}T${horas}:${minutos}:${segundos}`;
    return fechaFormateada;
  }






  async ActividadNuevaFunction() {

    this.cargando = true;

    let res: any = await this._sap.creaActualizaActividad(this.ActividadNueva);
    
    if (res.estado) {
      Swal.fire({
        icon: 'success',
        title: 'Éxito',
        text: res.mensaje,
      });
    }
    else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: res.mensaje,
      });
    }

    await this.cargaInicial();

    this.ActividadNueva = {
      "ClgCode": 0,
      "CardCode": this.data.CardCode,
      "Notes": "",
      "CntctDate": new Date(),
      "CntctTime": 1056,
      "Recontact": new Date(),
      "Closed": "N",
      "CloseDate": null,
      "ContactPer": null,
      "Tel": "990793427",
      "Fax": null,
      "CntctSbjct": -1,
      "Transfered": "N",
      "DocType": "-1",
      "DocNum": "",
      "DocEntry": "",
      "Attachment": "",
      "DataSource": "I",
      "AttendUser": 1,
      "CntctCode": 0,
      "UserSign": 1,
      "SlpCode": -1,
      "Action": "",
      "Details": "",
      "CntctType": -1,
      "Location": -1,
      "BeginTime": 1050,
      "Duration": 900.000000,
      "DurType": "S",
      "ENDTime": 1105,
      "Priority": "1",
      "Reminder": "Y",
      "RemQty": 15.000000,
      "RemType": "M",
      "OprId": 0,
      "OprLine": 0,
      "RemDate": new Date(),
      "RemTime": 1035,
      "RemSented": "N",
      "Instance": 0,
      "endDate": new Date(),
      "status": null,
      "personal": "N",
      "inactive": "N",
      "tentative": "N",
      "street": null,
      "city": null,
      "country": null,
      "state": null,
      "room": null,
      "parentType": "0",
      "parentId": 0,
      "prevActvty": null,
      "AtcEntry": null,
      "RecurPat": "N",
      "EndType": "N",
      "SeStartDat": new Date(),
      "SeEndDat": null,
      "MaxOccur": null,
      "Interval": 1,
      "Sunday": "N",
      "Monday": "N",
      "Tuesday": "N",
      "Wednesday": "N",
      "Thursday": "N",
      "Friday": "N",
      "Saturday": "N",
      "SubOption": "1",
      "DayInMonth": null,
      "Month": null,
      "DayOfWeek": null,
      "Week": null,
      "SeriesNum": null,
      "OrigDate": null,
      "IsRemoved": "N",
      "LastRemind": null,
      "AssignedBy": 1,
      "AddrName": null,
      "AddrType": "S",
      "AttendEmpl": null,
      "NextDate": null,
      "NextTime": null,
      "OwnerCode": null,
      "AttendReci": null,
      "ActType": null,
      "LaborItem": null,
      "ResCode": null,
      "FIPROJECT": null,
      "UpdateDate": new Date(),
      "LogInstanc": 0,
      "UserSign2": null,
      "DPPStatus": "N",
      "CreateDate": new Date(),
      "EncryptIV": null,
      "DataVers": 1,
      "Of365EvtId": null,
      "AssigneeTy": 12,
      "VersionNum": "10.00.180.08",
      "userFields": [
        {
          "Field": "U_IND_ID_INTRANET",
          "FieldType": null,
          "Value": localStorage.getItem("RUT_LOGUEADO"),
          "TypeHTML": null,
          "MaxLength": null,
          "Step": null,
          "Description": null
        },
        {
          "Field": "U_IND_ID_OPOR",
          "Value": this.id,
        }
      ]
    }

    this.cargando = false;

  }

  async verAdjunto(item: any) {
    let res: any = await this._sap.verAdjunto(item);
    if (res.estado) {
      window.open(environment.RUTA_API + res.resultado.rutaServerFile, '_blank');
    }
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];

    if (file) {
      this.readFile(file);
    }
  }

  readFile(file: File): void {
    const reader = new FileReader();

    reader.onloadend = async () => {
      const base64Data = reader.result as string;
      const fileName = file.name;
      const fileExt = this.getFileExtension(fileName);

      const fileInfo = {
        AbsEntry: -1,
        srcPath: base64Data,
        FileName: fileName,
        FileExt: fileExt
      };

      await this.creaArchivo(fileInfo);


      



    };

    reader.readAsDataURL(file);
  }

  getFileExtension(fileName: string): string {
    return fileName.slice((fileName.lastIndexOf('.') - 1 >>> 0) + 2);
  }

  async creaArchivo(file) {
    this.cargando = true;

    if (this.data.AtcEntry) {
      file.AbsEntry = this.data.AtcEntry;
    }
    else {
      file.AbsEntry = -1;
    }

    let res: any = await this._sap.creaActualizaAdjunto(file.AbsEntry, file.srcPath, file.FileName, file.FileExt);
    
    if (res.estado) {
      if (!this.data.AtcEntry) {
        this.data.AtcEntry = res.resultado.AbsEntry;
        await this._sap.creaActualizaOportunidad(this.data);
      }
      await this.cargaInicial()
      Swal.fire({
        icon: 'success',
        title: 'Éxito',
        text: res.mensaje,
      });
    }
    else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: res.mensaje,
      });
    }

    this.cargando = false;

  }

  changeFecha: boolean = false;

  verFecha() {
    this.changeFecha = !this.changeFecha;
  }

  changeMonto: boolean = false;

  verMonto() {
    this.changeMonto = !this.changeMonto;
  }

}
